// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"Sidebar_sidebarWrapper__AZuqn","hamburger":"Sidebar_hamburger__4CXex","sidebarContainer":"Sidebar_sidebarContainer__3SIb5","open":"Sidebar_open__QRRf+"};